module.exports = __webpack_public_path__ + "9b376adfe6537b56cbe23884645ce1ae.png";